import { FunctionComponent, Fragment } from 'react';
import { IAppProps } from '../../common/interface/IAppProvider';
import { useGlobalState } from '../../common/context/AppContext';
import bundle from '../../assets/progressbar.json';

export const ProgressBar: FunctionComponent<IAppProps> = (props: IAppProps): JSX.Element => {
    const { actualStep } = useGlobalState();
    const hippoTexts = bundle;

    if (actualStep === 0) {
        return <Fragment />;
    } else if (actualStep < 10 || props.pageType === 'receipt') {
        return (
            <Fragment>
                <div className="progress-bar-inner" />
            </Fragment>
        );
    } else {
        return (
            <Fragment>
                <div className={`progress-payment-bar-inner payment-step-${actualStep}`}>
                    <InsuranceInformation
                        label={hippoTexts['icon.house-sun.label'] || 'Valg af forsikring'}
                        className=" semi"
                    />
                    <Basket
                        label={hippoTexts['icon.basket.label']}
                        className={actualStep === 10 ? ' active' : actualStep > 10 ? ' semi' : ' dimmed'}
                    />
                    <AboutYou
                        label={hippoTexts['icon.identity.label']}
                        className={actualStep === 11 ? ' active' : actualStep > 11 ? ' semi' : ' dimmed'}
                    />
                    <StartDate
                        label={hippoTexts['icon.calendar.label']}
                        className={actualStep === 12 ? ' active' : actualStep > 12 ? ' semi' : ' dimmed'}
                    />
                    <Payment
                        label={hippoTexts['icon.payment.label']}
                        className={
                            actualStep > 12 && actualStep < 15 ? ' active' : actualStep > 14 ? ' semi' : ' dimmed'
                        }
                    />
                    <Accept
                        label={hippoTexts['icon.accept.label']}
                        className={actualStep > 14 ? ' active' : ' dimmed'}
                    />
                </div>
            </Fragment>
        );
    }
};

interface IIcon {
    label: string;
    className: string;
}
const InsuranceInformation = ({ label, className }: IIcon) => {
    return genericIcon(label, className, 'movables', '60', 0);
};

const Basket = ({ label, className }: IIcon) => {
    return genericIcon(label, className, 'basket', '50', 0);
};

const AboutYou = ({ label, className }: IIcon) => {
    return genericIcon(label, className, 'contacts', '71', 0);
};

const StartDate = ({ label, className }: IIcon) => {
    return genericIcon(label, className, 'cal', '50', -2);
};

const Payment = ({ label, className }: IIcon) => {
    return genericIcon(label, className, 'credit-cards', '71', 0);
};

const Accept = ({ label, className }: IIcon) => {
    return genericIcon(label, className, 'document-sign', '71', 0);
};

const genericIcon = (label: string, className: string, shape: string, size: string, top: number) => {
    return (
        <div className={`payment-wrapper${className}`}>
            <flos-icon class={`flos-icon icon-${shape}`} shape={shape} size={size} style={{ left: 0, top: top }} />
            <div className={`icon-text icon-text-${shape}`}>{label}</div>
        </div>
    );
};
